import { render, staticRenderFns } from "./UsersForLockDetailPage.vue?vue&type=template&id=ec85d6b0&"
import script from "./UsersForLockDetailPage.vue?vue&type=script&lang=js&"
export * from "./UsersForLockDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersForLockDetailPage.vue?vue&type=style&index=0&id=ec85d6b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports